export const BLOG_POSTS = [
  {
    slug: "tiktok-shop-dropshipping-malaysia",
    title: "TikTok Shop 一件代发马来西亚怎么开始？无需囤货模式完整指南",
    excerpt: "一件代发和传统囤货有什么不同？哪些商家适合、哪些不适合？流程、成本、风险和常见问题一次讲清楚。",
    date: "2026-08-26",
    updated: "2026-08-26",
    readTime: "阅读约 12 分钟",
    sections: [],
    faqs: [],
  },
  {
    slug: "how-to-start-tiktok-shop-malaysia",
    title: "TikTok Shop 马来西亚怎样开始？",
    excerpt: "写给马来西亚卖家的实际起步路线 —— 从注册到第一批像样的商品上架。",
    date: "2026-06-02",
    updated: "2026-07-01",
    readTime: "阅读约 6 分钟",
    sections: [
      { h: "先决定你的卖家类型", p: "在马来西亚，你可以用个人身份或公司（SSM）注册。个人注册比较快，但注册公司能解锁更多类别，买家看起来也比较可信。选择要看你卖什么、以及一年后你希望店铺变成怎样 —— 而不是只看今天哪个比较快。" },
      { h: "开始前先准备好资料", p: "打开 Seller Center 之前，先准备好身份资料、银行户口，以及（公司的话）SSM 资料。部分类别需要额外的认证文件，尤其是健康、美容和食品类产品。资料不齐是申请被卡住最常见的原因。" },
      { h: "把店铺当成店铺来设置，不是填表格", p: "店名、标志、店铺简介和取货设置，是买家最先看到的东西。把它们当成店面来决定，而不是表格栏位。清楚的店铺资料能建立信任，让第一次进来的客人愿意下单。" },
      { h: "用少而精的商品开张", p: "不要第一天就上传 200 个商品。先用一组完整的上架开张 —— 好标题、真实照片、完整描述。十个做得好的商品，胜过一百个随便上的。" },
      { h: "接下来做什么", p: "店铺上线后，重点就转到内容和运营。如果你希望有人带着你做，而不是自己摸索，可以直接在线找我们聊 —— 我们会坦白告诉你，你到底需不需要帮忙。" },
    ],
    faqs: [
      { q: "在马来西亚开 TikTok Shop 需要付费吗？", a: "注册本身是免费的。TikTok Shop 会在成交时收取佣金和交易费，费率因类别而异、也会调整，以 Seller Center 的最新资料为准。" },
      { q: "审核需要多久？", a: "审核时间由 TikTok Shop 决定，长短不一。资料完整、信息准确的提交能避开最常见的延迟。" },
      { q: "没有 SSM 可以卖吗？", a: "可以，用个人卖家身份注册 —— 但部分类别需要注册公司。注册前先确认你的类别要求。" },
    ],
  },
  {
    slug: "tiktok-shop-malaysia-seller-requirements",
    title: "马来西亚 TikTok Shop 开店需要什么资料？",
    excerpt: "注册前真正需要准备的东西 —— 文件、商业资料和类别规则。",
    date: "2026-06-05",
    updated: "2026-07-01",
    readTime: "阅读约 5 分钟",
    sections: [
      { h: "个人卖家 vs 公司卖家", p: "个人卖家需要个人身份文件和本人名字的银行户口。公司卖家需要 SSM 注册资料和公司银行户口。公司路线准备时间稍长，但之后不会被类别限制卡住。" },
      { h: "特定类别的要求", p: "食品、保健品、化妆品和电器类产品通常需要额外文件，例如相关的产品认证或许可。进货之前，先在 Seller Center 查清楚你的类别规则。" },
      { h: "物流和退货准备", p: "你需要一个取货地址，以及包装和退货的基本安排。这些设置在开店时就要配置，而且会直接影响店铺的表现指标。" },
      { h: "卖家最常卡住的地方", p: "文件和银行户口名字不一致、认证文件不完整、类别选错 —— 这是我们见过最多的三个问题。用一份短清单就能全部避开，这也是开店咨询在做的事。" },
    ],
    faqs: [
      { q: "需要公司银行户口吗？", a: "公司卖家需要。个人卖家可以用个人户口，但户口名字必须和身份文件完全一致。" },
      { q: "外国人可以在马来西亚开 TikTok Shop 吗？", a: "取决于居留身份和公司注册情况。以 Seller Center 目前的资格规定为准。" },
    ],
  },
  {
    slug: "common-tiktok-shop-mistakes-new-sellers",
    title: "新手做 TikTok Shop 最容易犯的错误",
    excerpt: "我们在马来西亚新店铺里最常看到的五个错误 —— 以及怎样避开。",
    date: "2026-06-22",
    updated: "2026-07-01",
    readTime: "阅读约 5 分钟",
    sections: [
      { h: "一次过上传所有商品", p: "匆忙上架的一堆弱商品页面，之后修改起来比一开始做好更费力。先小批上架、做完整。" },
      { h: "只用价格竞争", p: "永远有人卖得比你便宜。新店靠的是清楚、可信和回复快 —— 价格战以后再说。" },
      { h: "不回客户消息", p: "回复率影响转化，也影响平台怎样看待你的店铺。回复慢是慢性杀手。" },
      { h: "以为没有内容也会有订单", p: "TikTok Shop 是靠内容带流量的。没有内容的店铺等于没有门。即使是简单的产品视频，也会改变整个局面。" },
      { h: "每个星期都全部推翻", p: "不断重来让你学不到任何东西。每次改动给它两三个星期，看数据，再调整。" },
    ],
    faqs: [
      { q: "店铺做不好，第一个要修什么？", a: "通常是商品页面，然后是回复速度。这两个都在你控制范围内，而且见效最快。" },
      { q: "新手什么时候应该找人帮忙？", a: "认真做了一个月完全没有动静的时候 —— 或者开店之前，直接避开这些错误。两种情况下，先聊一聊都不用钱。" },
    ],
  },
  {
    slug: "tiktok-shop-product-listing-tips",
    title: "TikTok Shop 商品标题应该怎样写？",
    excerpt: "标题、图片、描述 —— 决定浏览量变不变订单的上架基本功。",
    date: "2026-06-12",
    updated: "2026-07-01",
    readTime: "阅读约 5 分钟",
    sections: [
      { h: "标题跟着买家的搜索方式写", p: "用最直接的语言，把产品类型和关键属性放前面 —— 尺寸、口味、型号。堆满关键词的标题看起来像垃圾广告，买家直接跳过。" },
      { h: "第一张图回答「这是什么」，接下来三张回答「为什么选你」", p: "先清楚展示产品，然后展示尺寸比例、使用情境和包装内容。每张图片都应该消除一个不下单的理由。" },
      { h: "描述用来消除疑虑，不是重复标题", p: "列清楚包含什么、尺寸、材质、用法和保固（如果有）。找不到答案的买家，通常就直接不买。" },
      { h: "规格选项保持简单", p: "太多差不多的选项会让买家选不下手。合理分组，把最多人买的设为默认选项。" },
    ],
    faqs: [
      { q: "一个商品应该放几张图？", a: "把可用的栏位用得有意义 —— 通常 5 到 8 张，覆盖产品、细节、比例、使用方式和包装。" },
      { q: "可以抄竞争对手的商品页面吗？", a: "可以研究，不要照抄。重复的内容没有加分，还可能带来平台政策问题。" },
    ],
  },
  {
    slug: "improve-tiktok-shop-product-pages",
    title: "怎样改善 TikTok Shop 商品页面？",
    excerpt: "先诊断，再修改：找出你的商品页面在哪一步流失客户，然后修那一步。",
    date: "2026-06-16",
    updated: "2026-07-01",
    readTime: "阅读约 6 分钟",
    sections: [
      { h: "先诊断，再重写", p: "有浏览没点击，问题在标题或主图。有点击没订单，问题在价格、评价或描述缺口。修真正坏掉的那一步。" },
      { h: "提高信息密度", p: "买家是扫读的。把关键信息 —— 尺寸、兼容性、保存期、包含什么 —— 放在扫读五秒内能找到的位置。" },
      { h: "诚实地使用社会证明", p: "真实的评价和真实的销量才有转化力。永远不要造假 —— 平台查得到，买家也感觉得到。" },
      { h: "每个月检查一次商品页面", p: "价格、库存、季节和竞争对手都在变。商品页面是活的资产，不是上传一次就完事。我们的商品优化服务就是把这套流程系统化。" },
    ],
    faqs: [
      { q: "商品页面最常见的错误是什么？", a: "假设买家已经认识这个产品。为陌生人写的页面，比为粉丝写的页面更能转化。" },
      { q: "商品页面放视频有帮助吗？", a: "简短的演示视频通常能让买家更快做决定，尤其是需要组装或用法不明显的产品。" },
    ],
  },
  {
    slug: "is-tiktok-shop-suitable-for-your-business",
    title: "马来西亚商家适合做 TikTok Shop 吗？",
    excerpt: "一份坦白的清单：哪些产品在马来西亚 TikTok Shop 做得好，哪些不适合。",
    date: "2026-06-26",
    updated: "2026-07-01",
    readTime: "阅读约 5 分钟",
    sections: [
      { h: "通常做得好的产品", p: "能在视频里演示、价格属于冲动消费范围、容易运输、利润扛得住平台费和优惠券的产品。美容、服装、家居、零食和小工具常常符合这个模式。" },
      { h: "比较吃力的产品", p: "需要长时间考虑的高价产品、无法视觉化展示的产品，以及利润极薄的产品。不是不能做，但需要刻意规划，不是开了店就会动。" },
      { h: "人手问题", p: "产品再好，没人经营店铺一样会失败。适不适合，一半看产品，一半看你有没有运营的时间 —— 或者有没有找人帮忙的计划。" },
      { h: "直接问，直接答", p: "这是我们 WhatsApp 咨询里最常被问的问题。告诉我们你卖什么，我们会坦白告诉你 TikTok Shop 适不适合 —— 有时候答案是「还不到时候」。" },
    ],
    faqs: [
      { q: "服务业可以用 TikTok Shop 吗？", a: "TikTok Shop 是为实体产品设计的。服务业通常用 TikTok 做曝光，在别的地方成交。" },
      { q: "什么价格范围最好卖？", a: "冲动消费的价格区间转化最快，但高价产品配合好的演示内容和信任感也能做。" },
    ],
  },
  {
    slug: "tiktok-shop-setup-guide-malaysian-smes",
    title: "TikTok Shop 有流量没订单怎么办？",
    excerpt: "流量进来了却没转化 —— 系统地找出问题在哪里。",
    date: "2026-06-09",
    updated: "2026-07-01",
    readTime: "阅读约 6 分钟",
    sections: [
      { h: "先确认流量从哪里来", p: "视频流量和搜索流量的买家意图不一样。视频进来的买家还在犹豫阶段，商品页面要做得更有说服力；搜索进来的买家已经在比价，价格和评价更关键。" },
      { h: "检查商品页面的基本功", p: "有流量没订单，八成问题在商品页面：主图不够清楚、标题没说到重点、描述回答不了问题、评价太少。逐项检查，不要凭感觉改。" },
      { h: "价格和优惠的呈现", p: "马来西亚买家对优惠券和包邮很敏感。确认你的价格结构在扣掉平台费和优惠后还有利润，并把优惠清楚地展示出来。" },
      { h: "什么时候该找人看", p: "如果你自己检查过一轮还是找不到原因，让运营团队帮你看一遍店铺通常更快。可以直接在线找我们聊，先诊断再决定要不要合作。" },
    ],
    faqs: [
      { q: "有流量没订单最常见的原因是什么？", a: "商品页面说服力不够，其次是价格和评价。流量只是把人带到门口，商品页面才是成交的地方。" },
      { q: "需要投广告吗？", a: "先把自然流量的转化修好再投。广告会放大你现在的转化水平 —— 好或坏。" },
    ],
  },
  {
    slug: "tiktok-shop-content-ideas-malaysian-sellers",
    title: "TikTok Shop 内容应该怎样规划？",
    excerpt: "适合马来西亚产品的内容角度 —— 不用照抄别人在做的。",
    date: "2026-06-19",
    updated: "2026-07-01",
    readTime: "阅读约 6 分钟",
    sections: [
      { h: "先展示问题，再展示产品", p: "大部分类别最有效的形式：先展示你的产品解决的烦恼，再展示产品解决它。简单、可重复，中文、马来文或英文都适用。" },
      { h: "把客户的真实问题拍成视频", p: "你的客服聊天记录就是内容日历。每个被重复问到的问题 —— 尺寸、成分、发货时间 —— 都是一条能帮你预先成交的视频。" },
      { h: "自然地使用马来西亚元素", p: "发薪日、节日季节、天气、本地幽默。为马来西亚人做的内容，效果永远好过泛泛的翻译内容。" },
      { h: "建立一个你做得到的节奏", p: "每周稳定三条合格视频，好过一周十条然后消失。如果规划这些让你觉得负担很大，我们的内容方向服务可以帮你把日历做出来。" },
    ],
    faqs: [
      { q: "需要露脸吗？", a: "不一定 —— 手部、产品和旁白的形式也很好用。稳定比露脸更重要。" },
      { q: "TikTok Shop 视频应该多长？", a: "短到能留住注意力 —— 大部分有效的带货视频在 15 到 45 秒之间。" },
    ],
  },
  {
    slug: "tiktok-shop-management-guide-malaysia",
    title: "TikTok Shop 日常运营需要做什么？",
    excerpt: "店铺日常管理实际包含哪些工作，以及什么时候值得交给别人做。",
    date: "2026-06-24",
    updated: "2026-07-01",
    readTime: "阅读约 7 分钟",
    sections: [
      { h: "每天要做的事", p: "订单准时处理、客户消息回复、商品价格和库存检查、评价回应。不光鲜，但店铺健康指标衡量的就是这些。" },
      { h: "每周的节奏", p: "看什么卖动、什么卖不动，规划内容，准备接下来的平台活动，更新表现弱的商品。每周复盘能把零散动作变成系统。" },
      { h: "每月的视角", p: "扣掉平台费和优惠后的利润、活动表现、商品去留 —— 该推什么、该退什么。管理到这里就变成了策略。" },
      { h: "自己做 vs 找人做", p: "团队里有人能每天负责，就自己做。店铺重要但没人有时间，代运营通常比请人划算。TKShopMY 的店铺管理服务就是为这个缺口准备的 —— WhatsApp 聊聊就能谈范围。" },
    ],
    faqs: [
      { q: "管理店铺每星期需要多少时间？", a: "小店每天至少也要 1–2 个小时。活动档期会更多。低估这个时间是很多店铺停滞的原因。" },
      { q: "马来西亚代运营一般多少钱？", a: "看范围 —— 只做商品维护和完整运营不一样。任何认真的服务商都是先了解你的店铺再报价。" },
    ],
  },
  {
    slug: "tiktok-shop-vs-shopee-malaysian-smes",
    title: "TikTok Shop 和 Shopee 哪个比较适合马来西亚 SME？",
    excerpt: "两个平台的逻辑完全不同。先看清楚，再决定精力放哪里。",
    date: "2026-06-29",
    updated: "2026-07-01",
    readTime: "阅读约 6 分钟",
    sections: [
      { h: "搜索 vs 发现", p: "Shopee 是搜索逻辑：买家来时已经知道自己要什么。TikTok Shop 是发现逻辑：买家通过内容认识你。前者奖励优化功夫，后者奖励内容能力 —— 最理想是两个都做。" },
      { h: "成本结构不同", p: "两个平台都收佣金、都有广告产品。TikTok Shop 多了内容成本 —— 做视频的时间或金钱。Shopee 多了价格竞争压力。用你的真实利润各算一遍。" },
      { h: "先做哪一个", p: "产品适合演示、你能做内容，TikTok Shop 从零起步可能更快。产品是搜索型的标准品，Shopee 的意图流量更早成交。很多 SME 最后两个都做，只是顺序要排对。" },
      { h: "两个都做又不 burnout", p: "商品逻辑共用，内容策略分开，人手安排要现实。如果你正在权衡这个决定，可以在线和我们聊，用你真实的数字来谈。" },
    ],
    faqs: [
      { q: "同一个产品可以两个平台都卖吗？", a: "可以 —— 大部分卖家都这样。只要定价策略一致、两边发货都可靠就行。" },
      { q: "TikTok Shop 会在马来西亚取代 Shopee 吗？", a: "不会。两个平台在并行成长，服务的是不同的购物场景。把它们当成互补的渠道。" },
    ],
  },
  {
    slug: "which-products-suit-tiktok-shop",
    title: "哪些产品适合 TikTok Shop？",
    excerpt: "判断产品在 TikTok Shop 有没有机会，看这四个条件。",
    date: "2026-07-06",
    updated: "2026-07-06",
    readTime: "阅读约 4 分钟",
    sections: [
      { h: "能不能在视频里展示", p: "TikTok Shop 靠内容带流量。能在 30 秒视频里演示效果、用法或前后的产品，天然有优势。看不见效果的产品，需要更多内容功夫。" },
      { h: "价格是否在冲动消费区间", p: "大部分成交发生在不需要深思的价格区间。高价产品不是不能做，但需要更强的信任和内容铺垫。" },
      { h: "利润扛不扛得住平台费用", p: "佣金、交易费、优惠券、运费补贴都要算进去。先算清楚到手利润，再决定投入。" },
      { h: "物流是否简单可靠", p: "易碎、需要冷链或安装的产品难度更高。标准包裹、低退货率的产品最适合起步。不确定的话，可以先 WhatsApp 问我们。" },
    ],
    faqs: [
      { q: "服务类产品可以做吗？", a: "TikTok Shop 以实体产品为主。服务业可以用 TikTok 内容做曝光，在别的地方成交。" },
      { q: "产品单价低还有机会吗？", a: "低价产品靠走量，关键是内容和物流成本控制。套装组合通常是低价产品的好做法。" },
    ],
  },
  {
    slug: "how-malaysian-businesses-start-tiktok-shop",
    title: "马来西亚商家应该怎样开始 TikTok Shop？",
    excerpt: "从评估产品到正式上线的实际路径，写给还没开始的本地商家。",
    date: "2026-07-08",
    updated: "2026-07-08",
    readTime: "阅读约 5 分钟",
    sections: [
      { h: "第一步不是注册，是评估", p: "先想清楚：产品适合内容电商吗？价格有竞争力吗？谁来做内容和出货？这三个问题比注册账号更重要。" },
      { h: "用小而完整的商品组合开始", p: "第一批上架 5–10 个最有把握的产品，把标题、图片、描述做完整，比一次上传全部库存有效。" },
      { h: "开店资料一次准备齐", p: "身份或 SSM 资料、银行户口、取货地址、类别所需认证 —— 提前准备好，申请一次过。" },
      { h: "给自己三个月的学习期", p: "前三个月的目标是弄清楚什么内容和产品组合有效，而不是追求销量数字。需要有人带的话，可以先在线咨询。" },
    ],
    faqs: [
      { q: "没有电商经验可以开始吗？", a: "可以。从基础设置和少量产品开始，边做边学。关键是有人告诉你先做什么、后做什么。" },
      { q: "整个过程要多久？", a: "资料齐全的话，开店设置几天内可以完成。真正花时间的是内容和运营的磨合期。" },
    ],
  },
  {
    slug: "tiktok-shop-for-physical-stores",
    title: "实体店适合做 TikTok Shop 吗？",
    excerpt: "实体生意增加线上渠道，适合什么情况、要注意什么。",
    date: "2026-07-10",
    updated: "2026-07-10",
    readTime: "阅读约 5 分钟",
    sections: [
      { h: "实体店的优势比想象中大", p: "你有现货、有真实店面可以拍内容、有熟客可以背书。这些是纯线上卖家没有的内容素材。" },
      { h: "从产品里挑「适合运输」的开始", p: "实体店全部产品都搬上线。先选耐运输、利润够、容易演示的品类。" },
      { h: "出货流程要先想好", p: "线上订单和门市客流同时来时，谁打包、谁发货？这个没有安排好，线上做起来反而拖累门市。" },
      { h: "内容可以就在店里拍", p: "产品演示、补货日常、客户反应 —— 店面本身就是最好的内容场景。想知道怎样规划，可以 WhatsApp 聊聊。" },
    ],
    faqs: [
      { q: "门市很忙，线上顾得过来吗？", a: "起步期每天留固定 1 小时处理线上订单即可。订单量上来后再考虑增加人手或运营支持。" },
      { q: "线上会不会影响门市价格？", a: "可以线上推特定套装或规格，避免直接比价。定价策略可以按渠道设计。" },
    ],
  },
  {
    slug: "should-shopee-sellers-join-tiktok-shop",
    title: "Shopee Seller 要不要做 TikTok Shop？",
    excerpt: "已经有 Shopee 的卖家，怎样判断值不值得增加一个渠道。",
    date: "2026-07-12",
    updated: "2026-07-12",
    readTime: "阅读约 5 分钟",
    sections: [
      { h: "两个平台的逻辑不同", p: "Shopee 是搜索逻辑，买家带着需求来。TikTok Shop 是发现逻辑，买家刷到内容才认识你。同一盘货，两种打法。" },
      { h: "你的优势是现成的", p: "商品资料、库存、发货流程都是现成的，起步成本比新手低很多。要补的只有内容这一块。" },
      { h: "先测试，不要全押", p: "拿 5–10 个在 Shopee 卖得好的产品试水温，配简单的演示视频，跑一个月看数据再决定投入。" },
      { h: "两个渠道互相配合", p: "TikTok 带来的品牌认知，有一部分会回流到你的 Shopee 搜索量。渠道不是互相抢生意，是互相加分。" },
    ],
    faqs: [
      { q: "价格需要比 Shopee 低吗？", a: "不需要刻意压低。用套装、赠品或平台优惠券制造差异，比直接降价健康。" },
      { q: "一个人顾两个平台现实吗？", a: "起步可以，但要排好优先级。订单量上来后，再考虑运营支持或人手。" },
    ],
  },
  {
    slug: "how-brands-start-tiktok-shop",
    title: "品牌怎样开始 TikTok Shop？",
    excerpt: "品牌方进入 TikTok Shop 的正确顺序：形象、内容、渠道。",
    date: "2026-07-14",
    updated: "2026-07-14",
    readTime: "阅读约 5 分钟",
    sections: [
      { h: "店铺形象就是品牌形象", p: "店名、视觉、商品页面风格要一致。消费者在 TikTok Shop 对你的第一印象，就是品牌印象。" },
      { h: "内容要有统一的表达", p: "品牌不适合零散发视频。先定内容方向：调性、语言、视觉风格，再开始发。" },
      { h: "价格体系要想清楚", p: "TikTok Shop 的促销文化浓。品牌要事先定好底线价和优惠策略，避免打乱其他渠道。" },
      { h: "用内容测产品组合", p: "不同内容带不同产品的数据，会告诉你品牌在这个渠道的主推款是什么。需要规划协助可以 WhatsApp 聊。" },
    ],
    faqs: [
      { q: "品牌适合自己做还是找人协助？", a: "策略和调性自己定，执行可以分工。关键是先有一套清楚的内容和店铺标准。" },
      { q: "需要直播吗？", a: "不是必须。短视频内容稳定后，再评估直播是否符合品牌调性和投入产出。" },
    ],
  },
];
